import { Component, inject, input } from '@angular/core';
import { Image } from '../header/header.component';
import { LightboxModule } from 'ng-gallery/lightbox';
import { Gallery } from 'ng-gallery';
import { BookingFormComponent } from './booking-form/booking-form.component';
import { BookingFullFormComponent } from './booking-full-form/booking-full-form.component';
import { StatusText } from '../contact-apartment/contact-apartment.component';
import { TranslatePipe } from '@ngx-translate/core';
import { BookingService } from '../../../services/booking.service';
import { DOMHandlerService } from '../../../services/domhandler.service';
import { BlockNode } from '../../../types/rich-text.types';
import { ButtonComponent } from '../../common/button/button.component';
import { RichTextComponent } from '../../common/rich-text/rich-text.component';
import { MapComponent, MapData } from '../../common/map/map.component';

@Component({
    selector: 'app-booking',
    imports: [
        LightboxModule,
        RichTextComponent,
        BookingFormComponent,
        MapComponent,
        BookingFullFormComponent,
        ButtonComponent,
        TranslatePipe,
    ],
    host: { class: 'container block mx-auto' },
    templateUrl: './booking.component.html',
})
export class BookingComponent {
    data = input.required<Booking>();
    domhandler = inject(DOMHandlerService);
    bookingService = inject(BookingService);

    constructor(private gallery: Gallery) {
        this.domhandler.addStructuredData(
            this.domhandler.getApartmentStructuredData(),
        );
    }

    ngOnInit() {
        const galleryRef = this.gallery.ref('booking-gallery');
        galleryRef.setConfig({
            loop: true,
            thumbs: true,
        });
    }
}

type Booking = {
    name: string;
    gallery: {
        images: Image[];
    };
    description?: BlockNode[];
    statusText: StatusText;
    map: MapData;
};
